<template>
  <div class="store-list">
    <el-card>
      <div slot="header" class="card-header">
        <span>店铺管理</span>
        <div class="header-right">
          <el-input
            v-model="searchKey"
            placeholder="请输入店铺名称/公司名/全名/SID"
            clearable
            style="width: 300px; margin-right: 10px;"
            @keyup.enter.native="handleSearch"
          ></el-input>
          <el-button type="primary" size="small" @click="handleSearch">
            <i class="el-icon-search"></i>
            搜索
          </el-button>
          <el-button type="success" size="small" @click="handleAdd" style="margin-left: 10px;">
            <i class="el-icon-plus"></i>
            新增店铺
          </el-button>
        </div>
      </div>
      <el-table :data="tableData" border stripe v-loading="loading">
        <el-table-column prop="sid" label="SID" width="120"></el-table-column>
        <el-table-column prop="nameCn" label="中文名" width="150"></el-table-column>
        <el-table-column prop="companyName" label="公司名" width="150"></el-table-column>
        <el-table-column prop="fullName" label="全名" width="150"></el-table-column>
        <el-table-column prop="shortName" label="简称" width="120"></el-table-column>
        <el-table-column prop="address" label="地址"></el-table-column>
        <el-table-column prop="contactPerson" label="联系人" width="100"></el-table-column>
        <el-table-column prop="contactPhone" label="联系电话" width="130"></el-table-column>
        <el-table-column prop="contactWx" label="微信" width="120"></el-table-column>
        <el-table-column label="关联品牌" width="250">
          <template slot-scope="scope">
            <el-tag v-for="brand in scope.row.brands" :key="brand.uid" size="small" style="margin-right: 5px; margin-bottom: 5px;">
              {{ brand.nameCn }}
            </el-tag>
            <span v-if="!scope.row.brands || scope.row.brands.length === 0" style="color: #909399;">-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleBindBrand(scope.row)">关联品牌</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="中文名" prop="nameCn">
          <el-input v-model="form.nameCn" placeholder="请输入中文名"></el-input>
        </el-form-item>
        <el-form-item label="公司名" prop="companyName">
          <el-input v-model="form.companyName" placeholder="请输入公司名"></el-input>
        </el-form-item>
        <el-form-item label="全名" prop="fullName">
          <el-input v-model="form.fullName" placeholder="请输入全名"></el-input>
        </el-form-item>
        <el-form-item label="简称" prop="shortName">
          <el-input v-model="form.shortName" placeholder="请输入简称"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="form.address" placeholder="请输入地址"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contactPerson">
          <el-input v-model="form.contactPerson" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="form.contactPhone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="微信" prop="contactWx">
          <el-input v-model="form.contactWx" placeholder="请输入微信"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog 
      title="关联品牌" 
      :visible.sync="brandDialogVisible" 
      width="700px"
      :close-on-click-modal="false"
      class="brand-dialog"
    >
      <div class="brand-select-wrapper">
        <el-transfer
          v-model="selectedBrandUids"
          :data="allBrands"
          :titles="['可选品牌', '已选品牌']"
          filterable
          filter-placeholder="搜索品牌名称"
          :button-texts="['移除', '添加']"
        ></el-transfer>
      </div>
      <div class="brand-dialog-footer" slot="footer">
        <div class="selected-info">
          <span>已选择 <strong>{{ selectedBrandUids.length }}</strong> 个品牌</span>
        </div>
        <div class="button-group">
          <el-button @click="brandDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSaveBrands" :loading="brandSubmitLoading">
            <i class="el-icon-check"></i>
            保存关联
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'StoreList',
  data() {
    return {
      tableData: [],
      searchKey: '',
      loading: false,
      dialogVisible: false,
      dialogTitle: '',
      form: {
        sid: null,
        nameCn: '',
        companyName: '',
        fullName: '',
        shortName: '',
        address: '',
        contactPerson: '',
        contactPhone: '',
        contactWx: ''
      },
      rules: {
        nameCn: [{ required: true, message: '请输入中文名', trigger: 'blur' }]
      },
      submitLoading: false,
      brandDialogVisible: false,
      brandSubmitLoading: false,
      currentStore: null,
      selectedBrandUids: [],
      allBrands: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  async mounted() {
    await this.loadData()
    await this.loadBrands()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        }
        if (this.searchKey) {
          params.searchKey = this.searchKey
        }
        const res = await this.$http.get('/shop/page', { params })
        if (res.code === '200') {
          this.tableData = res.data.list || []
          this.pagination.total = res.data.total || 0
        }
      } catch (error) {
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    async loadBrands() {
      try {
        const res = await this.$http.get('/brand/list')
        if (res.code === '200') {
          this.allBrands = (res.data || []).map(item => ({
            key: item.uid,
            label: item.nameCn
          }))
        }
      } catch (error) {
        console.error('加载品牌失败', error)
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.loadData()
    },
    handleAdd() {
      this.dialogTitle = '新增店铺'
      this.form = {
        sid: null,
        nameCn: '',
        companyName: '',
        fullName: '',
        shortName: '',
        address: '',
        contactPerson: '',
        contactPhone: '',
        contactWx: ''
      }
      this.dialogVisible = true
    },
    async handleEdit(row) {
      try {
        const res = await this.$http.get(`/shop/detail/${row.sid}`)
        if (res.code === '200') {
          const data = res.data
          this.dialogTitle = '编辑店铺'
          this.form = {
            sid: data.sid,
            nameCn: data.nameCn || '',
            companyName: data.companyName || '',
            fullName: data.fullName || '',
            shortName: data.shortName || '',
            address: data.address || '',
            contactPerson: data.contactPerson || '',
            contactPhone: data.contactPhone || '',
            contactWx: data.contactWx || ''
          }
          this.dialogVisible = true
        } else {
          this.$message.error(res.msg || '获取店铺详情失败')
        }
      } catch (error) {
        this.$message.error('获取店铺详情失败')
      }
    },
    async handleBindBrand(row) {
      this.currentStore = row
      try {
        const res = await this.$http.get(`/shop/detail/${row.sid}`)
        if (res.code === '200') {
          const detail = res.data
          this.currentStore = { ...row, brands: detail.brands || [] }
          this.selectedBrandUids = (detail.brands || []).map(b => b.uid)
        } else {
          this.selectedBrandUids = (row.brands || []).map(b => b.uid)
        }
      } catch (error) {
        this.selectedBrandUids = (row.brands || []).map(b => b.uid)
      }
      this.brandDialogVisible = true
    },
    async handleSaveBrands() {
      this.brandSubmitLoading = true
      try {
        const currentBrandUids = (this.currentStore.brands || []).map(b => b.uid)
        const toAdd = this.selectedBrandUids.filter(uid => !currentBrandUids.includes(uid))
        const toRemove = currentBrandUids.filter(uid => !this.selectedBrandUids.includes(uid))

        for (const uid of toRemove) {
          await this.$http.post('/shop/brand/remove', {
            sid: this.currentStore.sid,
            uid: uid
          })
        }

        for (const uid of toAdd) {
          await this.$http.post('/shop/brand/add', {
            sid: this.currentStore.sid,
            uid: uid
          })
        }

        this.$message.success('关联品牌成功')
        this.brandDialogVisible = false
        await this.loadData()
      } catch (error) {
        this.$message.error('关联品牌失败')
      } finally {
        this.brandSubmitLoading = false
      }
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.submitLoading = true
          try {
            const submitData = { ...this.form }
            console.log('提交数据:', submitData)
            
            const url = this.form.sid ? '/shop/update' : '/shop/add'
            const res = await this.$http.post(url, submitData)
            
            console.log('返回结果:', res)
            
            if (res.code === '200') {
              this.$message.success('操作成功')
              this.dialogVisible = false
              await this.loadData()
            } else {
              this.$message.error(res.msg || '操作失败')
            }
          } catch (error) {
            console.error('提交错误:', error)
            this.$message.error('操作失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.brand-dialog >>> .el-dialog__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  margin: 0;
  padding: 20px;
}

.brand-dialog >>> .el-dialog__title {
  color: white;
  font-size: 18px;
  font-weight: 600;
}

.brand-dialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: white;
  font-size: 20px;
}

.brand-dialog >>> .el-dialog__body {
  padding: 30px 20px;
}

.brand-select-wrapper {
  padding: 10px 0;
}

.brand-dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.selected-info {
  color: #909399;
  font-size: 14px;
}

.selected-info strong {
  color: #409eff;
  font-size: 18px;
  margin: 0 4px;
}

.button-group {
  display: flex;
  gap: 10px;
}
</style>
